import React, {useState} from 'react';
import useGetKjeder from '../../../../hooks/getKjeder';
import Loader from '../../../loader';
import VpAdminKjedeCard from '../../../VP/kjedeCards';
import styles from './kjeder.module.css';
import CustomAlert from '../../../customAlert';
import AddKjedeForm from '../../../VP/addKjedeForm';

export function VPadminKjedeside() {

    const [showModal, setShowModal] = useState(false);

    const { kjeder, isLoading, isError } = useGetKjeder();

    const onAddKjedeClick = () => {
        setShowModal(true);
    }

    const handleClose = () => {
        setShowModal(false);
    }

    if(isError) {
        return(
            <div>Oida, her har noe gått galt! Vennligst prøv igjen.</div>
        )
    }
    return(
        <div className={styles.container1}>
            {isLoading && <Loader />}
            <div className={styles.row1}><h2>Alle kjeder</h2></div>
            <div className={styles.container2}>
                <div className={styles.column1}>
                    <div className={styles.subHeader}>
                        Rediger kjeder
                    </div>
                    <div onClick={onAddKjedeClick} className={`${styles.button}`}>
                        Legg til kjede
                    </div>
                </div>
                <div className={styles.column2}>
                    <div className="row d-flex mx-0 flex-wrap justify-content-center">
                        {kjeder.map((kjede) => (
                            <div key={kjede.id} className="col-md-5 col-lg-2 col-9 mx-2 mb-4">
                                <VpAdminKjedeCard key={kjede.id} kjede={kjede} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <CustomAlert 
                show={showModal}
                handleClose={handleClose}
                message={<AddKjedeForm />}
                modalTitle="Legg til kjede"
                buttonLabel="Lukk"
            />
        </div>
    )
}

export default VPadminKjedeside;